export default __webpack_public_path__ + "static/media/arrow.5a2ad13f.svg";